// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.id-form {
  width: 55mm;
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/idCardForm/IdCardForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".id-form {\n  width: 55mm;\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
